import { type GetUserSessionsOptions } from '@/utils';

import {
  useGetAllSessionsQuery,
  useGetSessionsDashboardQuery,
  useGetSessionsQuery,
} from '@/store/api/sessionApi';

export const useSessions = (
  params: GetUserSessionsOptions,
  refetchOnMount: boolean | 'always' = false,
) => {
  const { currentData, data, isLoading, refetch } = useGetSessionsQuery(
    params,
    {
      refetchOnMountOrArgChange:
        refetchOnMount === 'always' || refetchOnMount === true,
    },
  );
  return { currentData, data, isLoading, refetch };
};

// MEN-4928: every page of the viewer's sessions, merged. Use this wherever
// the list is presented as complete (a long scroll with no pagination
// control); `useSessions` remains the single-page fetch for callers that own
// their own paging.
export const useAllSessions = (
  params: GetUserSessionsOptions,
  refetchOnMount: boolean | 'always' = false,
) => {
  const { currentData, data, isLoading, refetch } = useGetAllSessionsQuery(
    params,
    {
      refetchOnMountOrArgChange:
        refetchOnMount === 'always' || refetchOnMount === true,
    },
  );
  return { currentData, data, isLoading, refetch };
};

// `skip` lets a page that renders for non-member viewers hold the query back:
// /sessions/dashboard is a member-scoped endpoint and a coach, admin, or
// support viewer has no dashboard to read.
export const useSessionsDashboard = (options?: { skip?: boolean }) =>
  useGetSessionsDashboardQuery(undefined, options);
